<template>
  <v-flex class="pa-3">
    <div class="instructions-wrapper py-4">
      <v-avatar size="40" color="#4C2159" class="white--text"><b>4</b></v-avatar>
      <div class="px-2">
        <h2>Revisa y asigna</h2>
        <p>Revisa la optimización del sistema y asigna o personaliza una ruta</p>
      </div>
    </div>

    <template v-for="(vehicle, key) in sortedRoutes.routes">
      <v-card class="my-4" :key="vehicle.stops.location_id">
        <v-toolbar color="primary" dark>
          <v-toolbar-title>{{ Object.keys(sortedRoutes.routes).find(key => sortedRoutes.routes[key] === vehicle) }}</v-toolbar-title>
        </v-toolbar>

        <draggable
          :key="vehicle.stops.location_id"
          :list="vehicle.stops"
          :id="key"
          group="vehicle"
          animation="150"
          :multi-drag="true"
          selected-class="multi-drag"
          ghost-class="ghost"
          :move="moveChecker"
          @start="dragStart"
          @end="dragEnd"
        >
          <div v-for="(delivery, index) in vehicle.stops" :key="delivery.id" class="draggable-element">
            {{delivery.location_name}}
            <v-list v-if="delivery.location_name !== 'CEDIS'" :key="delivery.title">
              <v-list-item>
                <v-icon>drag_indicator</v-icon>
                <v-list-item-avatar>
                  <img :src="`https://ui-avatars.com/api/?color=fff&background=4C2159&size=128&name=${index}`">
                </v-list-item-avatar>

                <v-list-item-content>
                  <div>{{delivery.location_name}}
                  </div>
                  <v-list-item-subtitle>Hora estimada de llegada: {{ delivery.arrival_time }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </draggable>
      </v-card>
    </template>
  </v-flex>
</template>

<script>
import draggable from "vuedraggable";
import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'
import {
  mapState,
  mapGetter,
  mapActions
} from 'vuex'

const cardColors = [
  'azure',
  'beige',
  'bisque',
  'blanchedalmond',
  'burlywood',
  'cornsilk',
  'gainsboro',
  'ghostwhite',
  'ivory',
  'khaki'
]
const pickColor = () => {
  const rand = Math.floor(Math.random() * 10)
  return cardColors[rand]
}
export default {
  name: 'rake_changement1',
  components: {
      draggable,
  },
  data() {
    return {
      sortedRoutes: {"routes": {
          "vehicle_1": {
            "stops": [
              {
                "stop_id": 0,
                "order_id": 1,
                "location_id": "DEPOT",
                "location_name": "Centro de distribución",
                "lat": -100,
                "lng": 100,
                "arrival_time": "08:00",
                "departure_time": "16:00"
              },
              {
                "stop_id": 1,
                "order_id": 2,
                "location_id": "order_2",
                "location_name": "Foo Zaas",
                "lat": -100,
                "lng": 100,
                "arrival_time": "10:00",
                "departure_time": "10:15"
              },
              {
                "stop_id": 3,
                "order_id": 3,
                "location_id": "order_2",
                "location_name": "Foo Zaas",
                "lat": -100,
                "lng": 100,
                "arrival_time": "10:00",
                "departure_time": "10:15"
              }
            ],
            "cost_matrix": [
              [
                {
                  "distance_in_meters": 10,
                  "travel_time_in_minutes": 10
                },
                {
                  "distance_in_meters": 100,
                  "travel_time_in_minutes": 100
                }
              ],
              [
                {
                  "distance_in_meters": 10,
                  "travel_time_in_minutes": 10
                },
                {
                  "distance_in_meters": 100,
                  "travel_time_in_minutes": 100
                }
              ]
            ],
            "summary": {
              "depot_name": "DEPOT",
              "demand_assigned": 234,
              "distance_in_meters": 3004,
              "travel_time_in_minutes": 157,
              "waiting_time_in_minutes": 70.1
            }
          },
          "vehicle_2": {
            "stops": [
              {
                "stop_id": 0,
                "order_id": 1,
                "location_id": "DEPOT",
                "location_name": "Centro de distribución",
                "lat": -100,
                "lng": 100,
                "arrival_time": "08:00",
                "departure_time": "16:00"
              },
              {
                "stop_id": 1,
                "order_id": 2,
                "location_id": "order_2",
                "location_name": "Foo Zaas",
                "lat": -100,
                "lng": 100,
                "arrival_time": "10:00",
                "departure_time": "10:15"
              },
              {
                "stop_id": 3,
                "order_id": 3,
                "location_id": "order_2",
                "location_name": "Foo Zaas",
                "lat": -100,
                "lng": 100,
                "arrival_time": "10:00",
                "departure_time": "10:15"
              }
            ],
            "cost_matrix": [
              [
                {
                  "distance_in_meters": 10,
                  "travel_time_in_minutes": 10
                },
                {
                  "distance_in_meters": 100,
                  "travel_time_in_minutes": 100
                }
              ],
              [
                {
                  "distance_in_meters": 10,
                  "travel_time_in_minutes": 10
                },
                {
                  "distance_in_meters": 100,
                  "travel_time_in_minutes": 100
                }
              ]
            ],
            "summary": {
              "depot_name": "DEPOT",
              "demand_assigned": 234,
              "distance_in_meters": 3004,
              "travel_time_in_minutes": 157,
              "waiting_time_in_minutes": 70.1
            }
          }
        }
      },
      search: '',
      valid: false,
      dateRules: [v => !!v || 'Date is required'],
      errors: [],
      train: {},
      train_loading: false,
      trains: [],
      train_date: this.curTrainDate || moment().format('YYYY-MM-DD'),
      menu1: false,
      menu2: false,
      isLoading: false,
      summary: {}
    }
  },
  computed: {
    ...mapState(['curDeviceId', 'curDeviceName', 'curTrainNo', 'curTrainDate', 'curOrg', 'curArr', 'curDest', 'curDep','curCrewId',
     'actDep', 'actArr','curStartDate','curEndDate',]),
  },


  created() {

    console.log(this.train_date)
    console.log(this.curTrainDate)
    this.train_date= this.curTrainDate || moment().format('YYYY-MM-DD')
    //this.initialize(false)
  },

  methods: {
    ...mapActions(['updateCurDeviceId', 'updateCurDeviceName', 'updateCurTrainNo', 'updateCurTrainDate', 'updateCurOrg', 'updateCurCrewId',
     'updateCurArr', 'updateCurDest', 'updateCurDep', 'updateActDep', 'updateActArr','updateCurStartDate','updateCurEndDate']),
    initialize(calcall) {
      this.menu1 = false
      console.log(this.train_date)
      console.log(this.curTrainDate)
      this.updateCurTrainDate(moment(this.train_date).format("YYYY-MM-DD"))
        console.log(this.curTrainDate)
      //      console.log(this.curDeviceId)
      this.isLoading = true
      this.trains = []
      var p = {
        train_date: this.curTrainDate,
        calcall: calcall,
        start_date: this.$route.query.start_date,
        end_date: this.$route.query.end_date,
        crew_id: this.$route.query.crew_id,
        train_no: this.curTrainNo,
        device_id: this.curDeviceId,
        org: this.curOrg,
        dest: this.curDest,
      }
      console.log(p)
      var endPoint = 'reportforperiod'
      if (calcall) {
        endPoint = 'recalctrainreport'
      }
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`${process.env.VUE_APP_API_URL}/train/tr/${endPoint}`, {
          params: p
        })
        .then(response => {
          console.log(response);
          this.trains = response.data
          var rakewise_trains =_.sortBy( _.groupBy(response.data, 'device_name'), 'dep')
            console.log(rakewise_trains)
            var rakes =[]
          _.forEach(rakewise_trains, function(value, key) {
               console.log(key);
               var rake = {
                 id: `column${key}`,
                 type: 'container',
                 name: value[0]['device_name'],
                 props: {
                   orientation: 'vertical',
                   className: 'card-container'
                 },
                 children: []
               }
               _.forEach(value, function(v, k) {
                    console.log(k,v);
                    var train = {
                      type: 'draggable',
                      id: `${v['train_no']}`,
                      props: {
                        className: 'card',
                        style: {backgroundColor: pickColor(),fontSize: '12px'}
                      },
                      data: {
                        train_no: v['train_no'],
                        dep: v['dep'],
                        org: v['org'],
                        dest: v['dest'],
                        arr: v['arr']
                      }
                    }
                    rake.children.push(train)
               });
               rakes.push(rake)
          });
    //      this.scene.children = rakes
          this.summary = this.getSummary(response.data)
          this.isLoading = false
          this.updateCurCrewId(null)
          this.updateCurTrainNo(null)
          this.updateCurOrg(null)
          this.updateCurDest(null)
        })
        .catch(e => {
          console.log(e)
          this.isLoading = false
        })
    },
    moveChecker() {

    },
    dragStart() {

    },
    dragEnd() {

    },

      //update traccar_db.device_train_map set dep = addtime(train_date, time(dep)), arr = addtime(train_date, time(arr));
    //update traccar_db.device_train_map set arr = adddate(arr, 1) where arr < dep;
  getFormattedDate(t) {
      if (t) {
        var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
        var testDateUtc = moment.utc(lt);
        var localDate = moment(testDateUtc).local();
        return localDate.format("DD/MM/YYYY")
      } else {
        return '--'
      }
    },
    getFormattedTime(t) {
      if (t !== '--') {
       //  var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
       //  var testDateUtc = moment.utc(lt);
       // var localDate = moment(testDateUtc).local();
       //  return moment(localDate).format("HH:mm:ss")
       return moment.utc(t).format("HH:mm")
      }
    },
    getFormattedTimeSec(t) {
      if (t < 0) {
        return '-' + moment.utc(Math.abs(t) * 1000).format('HH:mm:ss')
      } else {
        return moment.utc(Math.abs(t) * 1000).format('HH:mm:ss')
      }
    },

    getColour(train) {
      if (train.act_arr) {
        let x = train.late_arr / 60
        switch (true) {
          case (x < 1):
            return 'green'
            break;
          case (x < 5):
            return '#6B8E23'
            break;
          case (x < 11):
            return 'blue'
            break;
          case (x < 21):
            return 'orange'
            break;
          case (x < 31):
            return '#FF1493'
            break;
          case (x < 1000):
            return 'red'
            break;
          default:
            return '#F5DEB3'
            break;
        }
      }
    },
    getSummaryColour(s) {
      return s == "more than 30" ? 'red' :
        s == "21 to 30" ? '#FF1493' :
        s == "11 to 20" ? 'orange' :
        s == "5 to 10" ? 'blue' :
        s == "less than 5" ? '#6B8E23' :
        s == "Right Time" ? 'green' :
        s == "total late" ? '#A52A2A' :
        s == "total train" ? '#D2691E' :
        s == "Puctuality" ? '#8A2BE2' :
        '#F5DEB3'
    },
    getSummary(trains) {
      let summary = {
        "Right Time": 0,
        "less than 5": 0,
        "5 to 10": 0,
        "11 to 20": 0,
        "21 to 30": 0,
        "more than 30": 0,
        "total late": 0,
        "total train": 0,
        "Puctuality": 0
      }
      _.forEach(trains, (train) => {
        if (train.act_arr) {
          let x = train.late_arr / 60
          switch (true) {
            case (x < 1):
              summary["Right Time"]++;
              summary["total train"]++;
              break;
            case (x < 5):
              summary["less than 5"]++;
              summary["Right Time"]++;
              summary["total train"]++;
              break;
            case (x < 11):
              summary["5 to 10"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            case (x < 21):
              summary["11 to 20"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            case (x < 31):
              summary["21 to 30"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            case (x < 1000):
              summary["more than 30"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            default:
              break;
          }
        }
      })
      summary["Puctuality"] = Math.round((summary["Right Time"] / summary["total train"]) * 100, 2)
      return summary
    }
  }
}
</script>
<style>
td, th{
  padding: 5px !important;
}

h2{
  font-size: 1.3em;
  font-weight: 500;
}

p{
  margin: 0;
  font-size: 14px;
}

.v-toolbar__title{
  font-size: 1.2em;
}

.v-list__item__subtitle {
  font-size: 0.8em;
}

.v-list{
  border-bottom: 1px #f1f1f1 solid;
}

.inline{
  display: inline;
}

.button-section-space-between{
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.instructions-wrapper{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.chip-text{
  padding: 0;
  margin: 0;
  font-size: 14px;
  font-weight: 700;
}

.v-autocomplete{
  font-size: 13px;
  max-width: 150px;
}

.v-autocomplete-wrapper{
  display: flex;
  justify-content: center;
  height: 100%;
}

.list-group{
  cursor: grab;
}

.draggable-element{
  background-color: royalblue;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.multi-drag {
  opacity: 0.5;
  background-color: red;
}
</style>
